module.exports = __webpack_public_path__ + "img/givu.2f71e358.png";